import * as TYPE from '../types';
const initialState = {};
export const paymentProviderReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.PAYMENT_PROVIDERS_FOUND:
      return { ...action.payload };
    default:
      return state;
  }
};
